import { render, staticRenderFns } from "./SingleUserOverview.vue?vue&type=template&id=56903362"
import script from "./SingleUserOverview.vue?vue&type=script&lang=ts"
export * from "./SingleUserOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports